/**
 * salesTaxLoaders: the Tax Compliance pages and the Sales Tax on Rentals
 * guide answer as an address that does not exist while an admin has the
 * Sales Tax switch off (Platform Fees; Tyler, 2026-10-21: "when it is off we
 * don't charge sales tax"). The switch that hid Tax Compliance in September
 * left a typed address reaching nothing too; this one shows the layout's
 * Page Not Found (RouteErrorBoundary).
 *
 * A switch that could not be read lets the page open, as every route check
 * does (readForRouteChecks): the page's own requests report the failure, and
 * the backend logs it.
 */
import type { LoaderFunctionArgs } from 'react-router'
import { salesTaxApi } from '@/redux/api/salesTaxApi'
import { readForRouteChecks } from '@/navigation/loaders/createAuthLoader'
import { storeLoader } from '@/navigation/loaders/storeLoader'
import { notFound } from '@/navigation/loaders/notFound'

/** Throws the not-found answer while the switch is off. */
const refuseWhileSalesTaxOff = async (): Promise<void> => {
  const salesTax = await readForRouteChecks(salesTaxApi.endpoints.getSalesTaxSwitch, 'sales tax switch')
  if (salesTax !== null && !salesTax.enabled) throw notFound()
}

/** Tax Compliance and its review, sign and receipt screens: the switch, then the store's own gate. */
export const taxComplianceLoader = async ({ request }: Pick<LoaderFunctionArgs, 'request'>) => {
  await refuseWhileSalesTaxOff()
  return storeLoader({ request })
}

/** The Sales Tax on Rentals guide, a public page: the switch alone. */
export const salesTaxGuideLoader = async () => {
  await refuseWhileSalesTaxOff()
  return null
}
